import { Link } from "gatsby";
import { Section, CodeWrapper, NcaLink } from 'nca-acquiring-theme';
import { springCloudSecretsManagerReferenceSnippet, springCloudSecretsManagerSnippet, springCloudSecretsManagerUsageSnippet } from "../../../../src/snippets/AwsSpringCloudSnippets";
import * as React from 'react';
export default {
  Link,
  Section,
  CodeWrapper,
  NcaLink,
  springCloudSecretsManagerReferenceSnippet,
  springCloudSecretsManagerSnippet,
  springCloudSecretsManagerUsageSnippet,
  React
};